module.exports = {
  accordion: {
    moreEntries: 'Show all BLOG entries',
  },
  cancel: {
    all: {
      all: 'Cancel',
    }
  },
  submit: {
    contact: {
      all: 'Send',
    }
  }
}